import './about.scss';
import {useTranslation} from "react-i18next";
import happyWoman from "../../../assets/images/home/happy_woman.jpg";
import umbrellaEarrings from "../../../assets/images/mission/Umbrella_Earrings.jpeg";
import blueEarrings from "../../../assets/images/mission/Smiling_face_blue_earrings.jpeg";
import blackEarrings from "../../../assets/images/mission/Smiling_face_black_earrings.jpeg";
import twoPrettyTeens from "../../../assets/images/mission/two_pretty_teens.jpeg";
import hamac from "../../../assets/images/about/Hamac.jpeg";
import paniers from "../../../assets/images/about/paniers.jpeg";
import colorfulEarrings from "../../../assets/images/about/colorful_earrings.jpg";
import EarringsInFrame from "../../../assets/images/about/earrings_in_frame.jpeg";
import crochetWoman from "../../../assets/images/home/woman_with_crochet_bijou.jpg";
import earringsCollection from "../../../assets/images/about/earrings_collection.jpg";
import headbandHand from "../../../assets/images/home/Headband_in_hand.jpeg";
import earringsWithPlants from "../../../assets/images/about/red_earrings_with_plants.jpg";
import guarijaHouse from "../../../assets/images/about/guarija_house.jpeg";
import firstEarrings from "../../../assets/images/about/first_earrings.jpeg";

const About = () => {
    const {t} = useTranslation()
    return (
        <div className={"About"}>
            <div className={"textes-wrapper"}>

                <div className={"section"}>
                    <div className={"section-paragraph"}>
                        <div className={"photo-and-text"}>
                            <div>
                                <h3 className={"section-title"}>{t("creators_word.title")}</h3>
                                <p className={"creator-word-p"}>{t("creators_word.texts.magic")}</p>
                            </div>
                            <img alt={"earrings collection"} src={crochetWoman} height={200}/>
                        </div>
                        <div className={"youtube-video"}>
                            <iframe
                                src="https://www.youtube.com/embed/7GER9do9ukg"
                                title="Creators word video"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>

                <div className={"section"}>
                    <div className={"section-paragraph"}>
                        <div className={"photo-and-text"}>
                            <div>
                                <h3 className={"section-title"}>{t("about_mission.title")}</h3>
                                <p>{t("about_mission.subtitle")}</p>
                                <p>{t("about_mission.texts.voice")}</p>
                                <p>{t("about_mission.texts.celebrate")}</p>
                            </div>
                            <img src={happyWoman} alt="" height={200} />
                        </div>
                        <div className={"photo-and-text"}>
                            <img src={umbrellaEarrings} alt="umbrella earrings" height={200} />
                            <img src={blueEarrings} alt="blue earrings" height={200} />
                            <img src={twoPrettyTeens} alt="two pretty teens" height={200} />
                            <img src={blackEarrings} alt="black earrings" height={200} />
                        </div>
                    </div>
                </div>

                <div className={"section"}>
                    <div className={"section-paragraph"}>
                        <div className={"photo-and-text"}>
                            <div>
                                <h3 className={"section-title"}>{t("about.title")}</h3>
                                <p>{t("about.subtitle")}</p>
                                <p>{t("about.texts.guarija")}</p>
                                <p>{t("about.texts.style")}</p>
                                <p>{t("about.texts.visual_impact")}</p>
                            </div>
                            <img alt={"paniers"} src={paniers} height={200}/>
                        </div>
                        <div className={"photo-and-text"}>
                            <img alt={"hamac"} src={hamac} height={200}/>
                            <img alt={"first_earrings"} src={firstEarrings} height={200}/>
                            <img alt={"guarija_house"} src={guarijaHouse} height={200}/>
                        </div>
                    </div>
                </div>

                <div className={"section"}>
                    <div className={"section-paragraph"}>
                        <div className={"photo-and-text"}>
                            <div>
                                <h3 className={"section-title"}>{t("about_product.title")}</h3>
                                <p>{t("about_product.subtitle")}</p>
                                <p>{t("about_product.texts.inspiration")}</p>
                                <p>{t("about_product.texts.foundation")}</p>
                                <p><b>{t("about_product.texts.wayuu")}</b>{t("about_product.texts.wayuu_content")}</p>
                                <p><b>{t("about_product.texts.dominican")}</b>{t("about_product.texts.dominican_content")}</p>
                            </div>
                            <img alt={"earrings collection"} src={earringsCollection} height={200}/>
                        </div>
                        <div className={"photo-and-text"}>
                            <img alt={"colorful earrings"} src={colorfulEarrings} height={200}/>
                            <img alt={"earrings in frame"} src={EarringsInFrame} height={200}/>
                            <img alt={"headband in hand"} src={headbandHand} height={200}/>
                        </div>
                    </div>
                </div>

                <div className={"section"}>
                    <div className={"section-paragraph"}>
                        <div className={"photo-and-text"}>
                            <div>
                                <h3 className={"section-title"}>{t("choose_us.title")}</h3>
                                <p><b>{t("choose_us.texts.ethics")}</b>{t("choose_us.texts.ethics_content")}</p>
                                <p><b>{t("choose_us.texts.connection")}</b>{t("choose_us.texts.connection_content")}</p>
                                <p><b>{t("choose_us.texts.cultural_identity")}</b>{t("choose_us.texts.cultural_identity_content")}</p>
                                <p><b>{t("choose_us.texts.comfort")}</b>{t("choose_us.texts.comfort_content")}</p>
                            </div>
                            <img alt={"earrings with plants"} src={earringsWithPlants} height={200}/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default About;
